export const ACCESS_MANAGER_PLATFORM_TAG = 'COCKPIT'
